import React, { useState } from 'react';
import { obtenerReservas } from '../data/reservas';
import './ExportarReservas.css';

const ExportarReservas = () => {
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);
  const [exportSuccess, setExportSuccess] = useState(false);

  const handleExportarReservas = async () => {
    setCargando(true);
    setError(null);
    setExportSuccess(false);

    try {
      // Obtener todas las reservas de Firebase
      const reservas = await obtenerReservas();
      
      // Preparar los datos para la exportación
      const reservasParaExportar = reservas.map(reserva => {
        // Determinar el nombre de la habitación
        let nombreHabitacion = 'No especificada';
        if (reserva.habitacionId) {
          nombreHabitacion = `Habitación ID: ${reserva.habitacionId}`;
        } else if (Array.isArray(reserva.habitaciones) && reserva.habitaciones.length > 0) {
          nombreHabitacion = reserva.habitaciones.map(h => h.nombre).join(', ');
        }
        
        // Formatear las fechas
        let fechaEntrada = reserva.fechaEntrada;
        let fechaSalida = reserva.fechaSalida;
        
        // Si la fecha es un objeto Timestamp, convertirlo a string ISO
        if (typeof reserva.fechaEntrada === 'object' && reserva.fechaEntrada.toDate) {
          fechaEntrada = reserva.fechaEntrada.toDate().toISOString();
        }
        
        if (typeof reserva.fechaSalida === 'object' && reserva.fechaSalida.toDate) {
          fechaSalida = reserva.fechaSalida.toDate().toISOString();
        }
        
        // Crear objeto con los datos formateados
        return {
          id: reserva.id,
          cliente: reserva.nombre || 'No especificado',
          email: reserva.email || 'No especificado',
          telefono: reserva.telefono || 'No especificado',
          habitacion: nombreHabitacion,
          fechaEntrada: fechaEntrada,
          fechaSalida: fechaSalida,
          duracionEstancia: reserva.duracionEstancia || 0,
          precioTotal: reserva.precioTotal || 0,
          fechaExportacion: new Date().toISOString()
        };
      });
      
      // Crear un objeto Blob con los datos
      const blob = new Blob([JSON.stringify(reservasParaExportar, null, 2)], { type: 'application/json' });
      
      // Crear una URL para el Blob
      const url = URL.createObjectURL(blob);
      
      // Crear un enlace y hacer clic en él para descargar el archivo
      const a = document.createElement('a');
      a.href = url;
      a.download = `reservas_hosteria_${new Date().toISOString().split('T')[0]}.json`;
      document.body.appendChild(a);
      a.click();
      
      // Limpiar
      setTimeout(() => {
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        setExportSuccess(true);
      }, 0);
    } catch (error) {
      console.error('Error al exportar reservas:', error);
      setError(error.message || 'Error al exportar las reservas');
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="exportar-reservas">
      <h2>Exportar Reservas</h2>
      
      <div className="exportar-info">
        <p>
          Exporta todas las reservas como un archivo JSON que puedes utilizar para sincronizar con Google Calendar.
          El archivo incluirá información detallada de todas las reservas, incluyendo clientes, fechas y habitaciones.
        </p>
      </div>
      
      {error && (
        <div className="error-message">
          {error}
        </div>
      )}
      
      {exportSuccess && (
        <div className="success-message">
          ¡Las reservas se han exportado correctamente!
        </div>
      )}
      
      <button 
        className="btn-exportar"
        onClick={handleExportarReservas}
        disabled={cargando}
      >
        {cargando ? 'Exportando...' : 'Exportar reservas a JSON'}
      </button>
      
      <div className="google-script-info">
        <h3>Sincronización con Google Calendar</h3>
        <p>Para sincronizar las reservas con tu calendario de Google, sigue estos pasos:</p>
        <ol>
          <li>Exporta las reservas utilizando el botón de arriba</li>
          <li>Sube el archivo JSON a tu Google Drive</li>
          <li>Accede a <a href="https://script.google.com" target="_blank" rel="noopener noreferrer">Google Apps Script</a></li>
          <li>Crea un nuevo proyecto y copia el código que te proporcionamos en las instrucciones</li>
          <li>Ejecuta el script para sincronizar las reservas con tu calendario</li>
        </ol>
      </div>
    </div>
  );
};

export default ExportarReservas; 